export default [
  {
    path: '/myOffer',
    name: 'myOffer',
    component: () => import('@/views/myOffer/index'),
    meta: {
      title: '我的报价'
    }, 
  },  
  {
    path: '/myOffer/myOfferDetail',
    name: 'myOfferDetail',
    component: () => import('@/views/myOffer/myOfferDetail'),
    meta: {
      title: '报价详情'
    }, 
  },
]